import { render, staticRenderFns } from "./graph_detail_robot.vue?vue&type=template&id=04c42676&"
import script from "./graph_detail_robot.vue?vue&type=script&lang=ts&"
export * from "./graph_detail_robot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports